export default "__VITE_ASSET__5zoAvfYu__"